/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/**
 * Defines how a person card is shown when a user interacts with
 * a person component
 *
 * @export
 * @enum {number}
 */
export var PersonCardInteraction;
(function (PersonCardInteraction) {
    /**
     * Don't show person card
     */
    PersonCardInteraction[PersonCardInteraction["none"] = 0] = "none";
    /**
     * Show person card on hover
     */
    PersonCardInteraction[PersonCardInteraction["hover"] = 1] = "hover";
    /**
     * Show person card on click
     */
    PersonCardInteraction[PersonCardInteraction["click"] = 2] = "click";
})(PersonCardInteraction || (PersonCardInteraction = {}));
//# sourceMappingURL=PersonCardInteraction.js.map